/**
 * The heading an element shows: the storyboard's own title, or the content
 * element's when the storyboard has none.
 *
 * A cleared title arrives from the Content Factory as an empty string rather
 * than a missing key, so blank counts as none.
 */
export const storyboardTitle = (
  title: string | undefined,
  contentElementTitle: string
): string => title?.trim() || contentElementTitle;
